import React from 'react';
import { useSelector } from 'react-redux';

const FilterInput = ({
	type,
	onChangeHandler,
	onApplyHandler,
	inputValue,
	placeHolderOne = 'Min',
	placeHolderTwo = 'Max',
	onClearInputFields,
	inputType = 'number'
}) => {
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);

	return (
		<>
			{selectedField?.selectedCheckboxField === type && (
				<div className="filter-submenu scroll-y-label">
					<div className="card border-0">
						<div className="card-body">
							<div className="col-md-12 p-0">
								<div className="form-group mb-2">
									<input
										type={inputType}
										placeholder={placeHolderOne}
										name="min"
										value={inputValue?.min}
										onChange={onChangeHandler}
										autoFocus={true}
									/>
								</div>
							</div>

							<div className="col-md-12 p-0">
								<div className="form-group mb-3">
									<input
										type={inputType}
										placeholder={placeHolderTwo}
										name="max"
										value={inputValue?.max}
										onChange={onChangeHandler}
									/>
								</div>
							</div>

							<div className="d-flex justify-content-end mt-3">
								<button className="button outline mr-2" onClick={onClearInputFields}>
									Cancel
								</button>
								<button
									className="button"
									onClick={() => {
										onApplyHandler();
										// onOutSideClick();
									}}
								>
									Apply
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default FilterInput;
